export default [
  { key: 'riskStatus', label: 'Risk', order: 'asc' },
  { key: 'callStatus', label: 'Call status', order: 'asc' }
];
